import axios from "axios";
import { useToast } from "vue-toastification";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    wishlist: [],
    status: {
      wishlist: {
        loading: false,
        error: "",
      },
      addToWishlist: {
        loading: false,
        error: "",
      },
    },
  },
  getters: {
    getWishListItems: (state) => state.wishlist,
    status: (state) => state.status,
  },
  actions: {
    async fetchWishlist({ commit }) {
      commit("setLoading", { dataName: "wishlist", status: true });
      let token = localStorage.getItem("token");
      try {
        let { data } = await axios.get(
          process.env.VUE_APP_API_URL + "/api/frontend/wishlists",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Wishlist Items", data.payload);
        commit("setWishlist", data.payload);
        commit("setLoading", {
          dataName: "wishlist",
          status: false,
        });
      } catch (error) {
        console.log(error);
        commit("setLoading", {
          dataName: "wishlist",
          status: false,
        });
        commit("setError", {
          dataName: "wishlist",
          error: error.response.data.message,
        });
        useToast().error(error.response.data.message, { timeout: 3000 });
      }
    },

    async addProductToWislist(
      { commit },
      { product_id, product_combination_id, warehouse_id }
    ) {
      commit("setLoading", { dataName: "addToWishlist", status: true });
      let token = localStorage.getItem("token");
      try {
        let { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/api/frontend/wishlists",
          { product_id, product_combination_id, warehouse_id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Added Item In Wishlist", data.payload);
        commit("updateWishlist", data.payload);
        commit("setLoading", {
          dataName: "addToWishlist",
          status: false,
        });
        useToast().success("Product added in wishlist", { timeout: 3000 });
      } catch (error) {
        console.log(error);
        commit("setLoading", {
          dataName: "addToWishlist",
          status: false,
        });
        commit("setError", {
          dataName: "addToWishlist",
          error: error.response.data.message,
        });
        useToast().error(error.response.data.message, { timeout: 3000 });
      }
    },

    async deleteProductFromWishlist({ commit }, wishlistId) {
      commit("setLoading", { dataName: "wishlist", status: true });
      let token = localStorage.getItem("token");
      try {
        let { data } = await axios.delete(
          process.env.VUE_APP_API_URL + "/api/frontend/wishlists/" + wishlistId,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Deleted Item In Wishlist", data.payload);
        commit("deleteWishlist", wishlistId);
        commit("setLoading", {
          dataName: "wishlist",
          status: false,
        });
        useToast().success("Wishlist Deleted", { timeout: 3000 });
      } catch (error) {
        console.log(error);
        commit("setLoading", {
          dataName: "wishlist",
          status: false,
        });
        commit("setError", {
          dataName: "wishlist",
          error: error.response.data.message,
        });
        useToast().error(error.response.data.message, { timeout: 3000 });
      }
    },

    async moveWishlistToCart({ commit }, {wishlist_id, warehouse_id}) {
      commit("setLoading", { dataName: "wishlist", status: true });
      let token = localStorage.getItem("token");
      try {
        let { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/api/frontend/wishlist-to-cart",
          {
            warehouse_id,
            wishlist_id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Moved To Cart", data.payload);
        commit("removeItemFormWishlist", wishlist_id)
        this.dispatch('cart/fetchCart');
        // commit("clearWishlist");
        commit("setLoading", {
          dataName: "wishlist",
          status: false,
        });
        // window.location.href = '/cart'
        useToast().success("Wishlist Moved to cart.", { timeout: 3000 });
      } catch (error) {
        console.log(error);
        commit("setLoading", {
          dataName: "wishlist",
          status: false,
        });
        commit("setError", {
          dataName: "wishlist",
          error: error.response.data.message,
        });
        useToast().error(error.response.data.message, { timeout: 3000 });
      }
    },
  },
  mutations: {
    setWishlist: (state, payload) => {
      state.wishlist = payload;
    },
    updateWishlist: (state, payload) => {
      state.wishlist.push(payload);
    },
    removeItemFormWishlist: (state, payload) => {
      state.wishlist = state.wishlist.filter(el => el.id !== payload);
    },
    deleteWishlist: (state, payload) => {
      state.wishlist = state.wishlist.filter(
        (wishlist) => wishlist.id != payload
      );
    },
    clearWishlist : (state) => {
      state.wishlist = [];
    },
    setLoading: (state, { dataName, status }) => {
      state.status[dataName].loading = status;
    },
    setError: (state, { dataName, error }) => {
      state.status[dataName].error = error;
    },
  },
};
